import { createContext } from "react";

const HamburgerMenuContext = createContext({});

export default HamburgerMenuContext;
